import useStyles from '../Styles/useStyles'
import NavBar from '../Components/NavBar'
import { formatCnpj, onlyNumber } from '../helpFunctions'
import React, {Fragment, useState, useEffect} from 'react'
import { useHistory } from 'react-router-dom'
import { Container, Grid, TextField, Button, Tabs, Tab, Paper, Typography, CircularProgress } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import '../App.css'
import http from '../Services/http'
import ImagemEmpresa from '../Components/ImagemEmpresa'
import { useAviso } from '../Context'

const Home = () => {
  const history = useHistory();
  const classes = useStyles();

  const [nota, setNota] = useState("");
  const [cnpjTab1, setCnpjTab1] = useState("");
  const [cnpjTab2, setCnpjTab2] = useState("");
  const [isLoading, setIsLoading] = useState(null);
  const [senha, setSenha] = useState("");
  const [boletos, setBoletos] = useState([]);
  const { setAviso } = useAviso();

  const [tab, setTab] = useState(0)
  const [warning, setWarning] = useState(false)

  useEffect(() => {
    sessionStorage.setItem('pathname', '/')
  }, [tab, warning])

  const handleChange = (name, value) => {
    if (tab === 0) {
      if (name === "nota") 
        setNota(onlyNumber(value))
      else 
        setCnpjTab1(onlyNumber(value))
    }
    else {
      if (name === "cnpjTab2") 
        setCnpjTab2(onlyNumber(value))
      else 
        setSenha(value)
    }
  }

  const reqBoletosNota = () => {
    http.get(`api/boletosNota?nota=${nota}&cnpj=${formatCnpj(cnpjTab1)}`, {
    }).then( (res) => {
      if (res.data.data.length === 0)
        setWarning(true);
      else {
        sessionStorage.setItem('pathname', '/lista_boletos');
        history.push({pathname: '/lista_boletos', state: {'data':res.data.data, 'tab':tab, 'nota': nota} });
      }
        
    }).catch(() => { return false; })
  }

  const reqMeusBoletos = () => {
    http.get(`api/meusBoletos?cnpj=${formatCnpj(cnpjTab2)}&senha=${senha}`, {
    }).then( (res) => {
      if (res.data.data.length === 0)
        setWarning(true);
      else {
        sessionStorage.setItem('pathname', '/lista_boletos');
        history.push({pathname: '/lista_boletos', state: {'data':res.data.data, 'tab':tab, 'nota': ''} })
      }
        
      
    }).catch(() => { return false; })
  }

  const handleClick = () =>{
    if (tab === 0){
      reqBoletosNota();
    }
    else{
      reqMeusBoletos();
    }
  }

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
    setWarning(false)
  }

  const handleClose = () => {
    setWarning(false)
  }


  const handleAlteraSenha = () => {
    http.post(`api/atualizaSenha`, { cnpj: formatCnpj(cnpjTab2)})
    .then(res => {
      setAviso(res.data)
      setIsLoading(false)
    })
    .catch(() => { 
      setAviso({ open: true, message: "Erro ao conectar-se ao servidor", severity: "error" })
      setIsLoading(false)
    })

    
  }

  const alertWaning = (texto) => {
    return(
      <Fragment>
        <Grid container justify="center">
          <Alert onClose={handleClose} variant="filled" severity="warning" style={{marginTop:'5px'}}>
              {texto}
          </Alert>
        </Grid> 
      </Fragment>
    );
  }

  const renderTab1 = () => {
    return(
      <Fragment>
        <form className={classes.form} noValidate>
          <Grid container justify="center">
          <TextField variant="outlined" margin="normal" value={nota} required fullWidth id="nota" label="Numero da Nota" name="nota" autoComplete="Numero da Nota" autoFocus
          onChange={(e) => handleChange(e.target.name, e.target.value)} onFocus={() => setWarning(false)}/>
          
          <TextField variant="outlined" margin="normal" value={cnpjTab1} required fullWidth id="cnpjCPF" label="CNPJ" name="cnpjTab1" autoComplete="CNPJ" 
          onChange={(e) => handleChange(e.target.name, e.target.value)} onFocus={() => setWarning(false)}/>
          </Grid>
            {
              warning === true ? alertWaning("Boleto não disponível") : null
            }
          <Grid container justify="center">
            <Button type="button" fullWidth onClick={handleClick} >Localizar</Button>
          </Grid>
        </form>
      </Fragment>
    )
    
  }

  const renderTab2 = (loading) => {
    return(
      <Fragment>
        <form className={classes.form} noValidate>
          <Grid container justify="center">
          <TextField variant="outlined" margin="normal" value={cnpjTab2} required fullWidth id="cnpjCPF" label="CNPJ" name="cnpjTab2" autoComplete="CNPJ" autoFocus
          onChange={(e) => handleChange(e.target.name, e.target.value)} onFocus={() => setWarning(false)}/>
          <TextField variant="outlined" type="password" margin="normal" value={senha} required fullWidth id="senha" label="Senha" name="senha" autoComplete="Senha" 
          onChange={(e) => handleChange(e.target.name, e.target.value)} onFocus={() => setWarning(false)}/>
          <Typography  onClick={() => { 
            if (cnpjTab2.toString() === "") {
              setAviso({ open: true, message: "Informe algum CNPJ.", severity: "warning" })
              return;
            }
            if (!isLoading) { setIsLoading(true); handleAlteraSenha(); } }} style={{ cursor: "pointer"}}>
            Clique aqui para receber ou resetar sua senha </Typography>
          { loading === true ? ( <CircularProgress size={20} style={{marginLeft: "5px"}}/> ) : null }
          
          </Grid>
            {
              warning === true ? alertWaning("CNPJ/Senha Inválidos") : null
            }
          <Grid container justify="center">
            <Button type="button" fullWidth onClick={handleClick}>Localizar</Button>
          </Grid>
        </form>
      </Fragment>
    )
  }

  return(
    <Fragment>
      <NavBar/>
      <Container maxWidth="sm">
        <ImagemEmpresa width="40%"/>
        <Paper className={classes.root} style={{marginTop:'1.5rem'}}>
          <Tabs value={tab} onChange={handleTabChange} centered>
            <Tab label="Boletos da Nota" />
            <Tab label="Boletos em Aberto" />
          </Tabs>
        </Paper>
        {tab === 0 ? renderTab1() : renderTab2(isLoading)}
      </Container>
    </Fragment>
  )
  
}

export default Home;